import default_avatar from '../components/topic/assets/default-avatar.png';
import address_yellow from '../components/topic/assets/address_yellow.png';

export const WX_APP_ID = 'wx4e9cc6da9aa26fa9';

export const DEFAULT_AVATAR = default_avatar;
export const ADDRESS_YELLOW = address_yellow;

export const DOWNLOAD_IMG = {
  FEED: 'https://pet-worm.51downapp.cn/4d8adf50_FEED.png',
  PERSPECTIVE: 'https://pet-worm.51downapp.cn/86a2e58b_PERSPECTIVE.png',
  ENTER_HOUSE: 'https://pet-worm.51downapp.cn/5b10669c_ENTER_HOUSE.png',
  INTRO_VIDEO: 'https://pet-worm.51downapp.cn/0f1fd4d3_INTRO_VIDEO.png',
  PAUSE_BTN: 'https://pet-worm.51downapp.cn/57f893d9_PAUSE_BTN.png',
  SURPORT_GOOD: 'https://pet-worm.51downapp.cn/98544cbb_SURPORT_GOOD.png',
  WX_CHAT: 'https://pet-worm.51downapp.cn/6188532a_WX_CHAT.png',
  RE_PLAY: 'https://pet-worm.51downapp.cn/ce76a12c_RE_PLAY.png',
  LIVING_PEO: 'https://pet-worm.51downapp.cn/b6dd91e6_LIVING_PEO.png',
  LIVING_FOOD: 'https://pet-worm.51downapp.cn/0b2ba18b_LIVING_FOOD.png',
};

export const GROUP_SHARE_DEFAULT = 'https://resource.51downapp.cn/group_share_default.png';
export const GROUP_HEAD_BG = 'https://m.hellobike.com/resource/helloyun/13543/EIpwT_top-bg.png';
export const GROUP_TEXT_QUOT = 'https://m.hellobike.com/resource/helloyun/13543/9PV1-_quot.png';
export const GROUP_MEMBER_AVATAR = 'https://m.hellobike.com/resource/helloyun/13543/RLhZs_people.png';
export const GROUP_EXP_IMG = 'https://resource.51downapp.cn/group_exp_icon.png';

export const TOPIC_IMG = {
  APP_ICON: 'https://resource.51downapp.cn/街猫app.png',
  TOPIC_BG: 'https://resource.51downapp.cn/话题标题背景.png',
  TOPIC_TIP: 'https://resource.51downapp.cn/话题icon.png',
  APP_BOTTOM: 'https://resource.51downapp.cn/Group 753.png',
  TOPIC_ATTENTION: 'https://resource.51downapp.cn/ico_关注.png',
  MOMENT_SHARE: 'https://resource.51downapp.cn/分享.png',
  MOMENT_COMMENT: 'https://resource.51downapp.cn/评论.png',
  MOMENT_LIKE: 'https://resource.51downapp.cn/like@3x.png',
  LIKE_ICON: 'https://resource.51downapp.cn/点赞灰.png',
  TOPIC_DOWN: 'https://resource.51downapp.cn/no-moment.png',
  LIKE_GREY: 'https://resource.51downapp.cn/点赞灰.png',
  MORE_COMMENT: 'https://resource.51downapp.cn/more-comment.png',
};

export const LIVING_IMG = {
  ADD_CARE: 'https://m.hellobike.com/resource/helloyun/22132/OmMug-lU7x.png',
  STOP: 'https://m.hellobike.com/resource/helloyun/22132/Ia_5XxQrYb.png',
};

export const ACTIVITY_IMG = {
  RAISE_BOX:
    'https://m.hellobike.com/resource/helloyun/22132/B1bl4_food_box.png',
  RAISE_TARGET:
    'https://m.hellobike.com/resource/helloyun/22132/JSoIg_raise_target.png',
  RULE_CLOSE:
    'https://m.hellobike.com/resource/helloyun/22132/dqkE2_rule_close.png',
  BAR_BACK:
    'https://m.hellobike.com/resource/helloyun/22132/lgKhB_back_icon.png',
  BAR_SHARE:
    'https://m.hellobike.com/resource/helloyun/22132/9T5SQ_share_icon.png',
  INTR_TITLE:
    'https://m.hellobike.com/resource/helloyun/22132/vLS5F_intr_title.png',
  BG_TREE:
    'https://m.hellobike.com/resource/helloyun/22132/yP5ae_1iXKZx64W2%202.png?',
  BG_CAT_RAISE:
    'https://m.hellobike.com/resource/helloyun/22132/x2xvr_g04vQsW4Ct%202.png',
  BG_CAT_FEED: 'https://m.hellobike.com/resource/helloyun/22132/3fjfMhVgkj.png',
  BG_GRASS: 'https://m.hellobike.com/resource/helloyun/22132/FF7O-Z59Sk.png',
  BG_GRASS_TWO:
    'https://m.hellobike.com/resource/helloyun/22132/BISrHihZcC.png',
  BG_TITLE: 'https://m.hellobike.com/resource/helloyun/22132/_YH2SKiZSP.png',
  BOX_UNDER:
    'https://m.hellobike.com/resource/helloyun/22132/3ncMF_raise_box_one.png',
  ACTIVITY_RULE:
    'https://m.hellobike.com/resource/helloyun/22132/nADt1_activity_rule.png',
  ACTIVITY_REWARD:
    'https://m.hellobike.com/resource/helloyun/22132/hWQw7bqu_T.png',
  HELP_CAT_TITLE:
    'https://m.hellobike.com/resource/gallery/64/KRpMC2Ub_taichi_image.png',
};

export const SHAREMONTHLYCARD_IMG = {
  ERROR_VIEW:
    'https://m.hellobike.com/resource/helloyun/wb28722/Vd6Uu_error.png',
  OVERDUE_VIEW:
    'https://m.hellobike.com/resource/helloyun/wb28722/1Jp6a_overdue-2.png',
  ICON_CLOSE:
    'https://m.hellobike.com/resource/helloyun/wb28722/Jt2Il_icon-close.png?x-oss-process=image/quality,q_80',
  POPUP_TIP_FEEDING:
    'https://m.hellobike.com/resource/gallery/122/5cB1k8s3_2.png',
  POPUP_TIP:
    'https://m.hellobike.com/resource/helloyun/wb28722/0-FE2_popup-tip.png?x-oss-process=image/quality,q_80',
  POPUP_TIP_MGM:
    'https://m.hellobike.com/28c708e4_taichi_image.png',
  REGISTERBG:
    'https://m.hellobike.com/resource/helloyun/wb28722/FoqZq_form.png',
  REGISTERBG_CAT:
    'https://m.hellobike.com/resource/gallery/122/0Z_NhWhz_Group%201312323350%20(1).png',
  SHARE_LOGO:
    'https://m.hellobike.com/resource/gallery/186/bOvYBavy_taichi_image.png',
  SHARE_VIDEO:
    'https://m.hellobike.com/resource/helloyun/14499/BIuBw_9458C0F9-DCBF-47AC-9FD0-FC53AB8AC2F8.mp4',
  CAT_TIP:
    'https://m.hellobike.com/resource/helloyun/wb28722/N33Zt_liebianmao_4.png',
  CARD_TEXT:
    'https://m.hellobike.com/resource/gallery/122/aApuOe9j_Group%201312323425.png',

  SIGN_SUCCESS_IMAGE: 'https://m.hellobike.com/resource/gallery/64/8AC0fWN6_taichi_image.png',
};

export const baseAppPath = 'hellopet://hellobike.com/bifrost?name=AppPetWXSS&mrEnableKeepAlive=NO&appId=2021000000000016&page=';

export const antiAbuseSharePath = 'hellopet://hellobike.com/bifrost?name=AppPetWXSS&mrEnableKeepAlive=NO&appId=2021000000000016&page=pages%2Factivity%2Fanti-abuse-invite%2Fanti-abuse-invite%3Fsource%3Dh5%26traceId%3D1534bf1140020&disabledSocket=1&traceId=1534bf1140020&appClearTop=NO&startMultApp=YES';
